module.exports = __webpack_public_path__ + "static/grandmarch-174443e0da0af6aa5f2ade4227e19fd4.png";